<template>
  <div
    :class="{
      disabled: disabled,
      checkbox: mode == 'checkbox',
      disSelect: true,
    }"
    ondragstart="return false"
    onselectstart="return false;"
  >
    <div
      class="option"
      :label="option.id"
      v-for="(option, index) in options"
      :key="option.id"
    >
      <span
        v-if="mode == 'radio'"
        @click="onOptionClick(option.id)"
        class="char"
        :class="{ checked: value == option.id }"
      >
        {{ String.fromCharCode(65 + index) }}
      </span>
      <span
        v-else-if="mode == 'checkbox'"
        @click="onOptionClick(option.id)"
        class="char"
        :class="{ checked: value && value.includes(option.id) }"
      >
        {{ String.fromCharCode(65 + index) }}
      </span>
      <div class="rich-text clearfix" @click="onContentClick">
        <div v-html="option.content"></div>
      </div>
    </div>
    <ImageViewer :isShow.sync="showImageViewer" :images="images"></ImageViewer>
  </div>
</template>
<script>
import ImageViewer from "@/components/ImageViewer.vue";
export default {
  name: "QuestionOption",
  components: {
    ImageViewer,
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    value: {},
    disabled: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: "radio",
    },
  },
  model: {
    prop: "value",
    event: "change",
  },
  data() {
    return {
      images: [],
      showImageViewer: false,
    };
  },
  methods: {
    onOptionClick(id) {
      if (this.disabled) {
        return;
      }
      if (this.mode == "radio") {
        this.$emit("change", id);
      } else if (this.mode == "checkbox") {
        let items = [...this.value];
        let index = items.indexOf(id);
        if (index < 0) {
          items.push(id);
        } else {
          items.splice(index, 1);
        }
        this.$emit("change", items);
      }
    },
    onContentClick(event) {
      let target = event.target;
      if (target.tagName.toLowerCase() == "img") {
        event.stopPropagation();
        this.images = [target.src];
        this.showImageViewer = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.option {
  font-size: 16px;
  color: #333333;
  font-weight: 400;
  display: flex;
  line-height: 26px;
  display: flex;
  margin-bottom: 23px;
  &:last-child {
    margin-bottom: 0;
  }
}
//控制不能选中
.disSelect {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.checkbox {
  .char {
    border-radius: 3px;
  }
}

.disabled {
  .char {
    cursor: not-allowed;
  }
}

.char {
  width: 26px;
  height: 26px;
  border: 1px solid rgba(191, 191, 191, 1);
  border-radius: 50%;
  font-size: 16px;
  color: #000000;
  display: inline-block;
  text-align: center;
  line-height: 24px;
  margin-right: 13px;
  box-sizing: border-box;
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    color: $primary-color;
    border-color: $primary-color;
  }

  &.checked {
    background: $primary-color;
    border-color: $primary-color;
    color: white;

    &:hover {
      background: $primary-color-hover;
      border-color: $primary-color-hover;
    }
  }
}
</style>
